import React, { useContext } from 'react';
import { TooltipContext } from './Tooltip';

const Tooltip: React.FC = ({ children }) => {
  const { setTooltipVisibility } = useContext(TooltipContext);

  return (
    <div
      onMouseEnter={() => setTooltipVisibility(true)}
      onMouseLeave={() => setTooltipVisibility(false)}
    >
      {children}
    </div>
  );
};
export default Tooltip;
